<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="item in details" :key="item.name">
          <td>
            <b>{{ item.name }}</b>
          </td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  mounted: async function () {
    this.section = this.$route.params.section;
    this.id = this.$route.query.id || this.$route.query.qualificationId;

    await this.getCertificationTemplates();
    await this.getUnits();

    if (this.item) {
      this.writeToTable(this.item);
    } else if (this.id) {
      await this.getQualification();
    }
  },
  data() {
    return {
      units: [],
      details: [],
      certificationTemplates: [],
      mapper: [
        {
          name: "Qualification Name",
          mapTo: "name",
        },
        {
          name: "Qualification Code",
          mapTo: "code",
        },
        {
          name: "QAN",
          mapTo: "qan",
        },
        {
          name: "Qualification Description",
          mapTo: "description",
        },
        {
          name: "Qualification Type",
          mapTo: "type",
        },
        {
          name: "Qualification Level",
          mapTo: "level",
        },
        {
          name: "Qualification Credits",
          mapTo: "credits",
        },
        {
          name: "Qualification Status",
          mapTo: "status",
        },
        {
          name: "Qualification Note",
          mapTo: "note",
        },
        {
          name: "No. of Mandatory Units",
          mapTo: "noOfMandatoryUnits",
        },
        {
          name: "Mandatory Units",
          mapTo: "mandatoryUnits",
        },
        {
          name: "No. of Optional Units",
          mapTo: "noOfOptionalUnits",
        },
        {
          name: "Optional Units",
          mapTo: "optionalUnits",
        },
        {
          name: "Qualification Start Date",
          mapTo: "startDate",
        },
        {
          name: "Qualification Review Date",
          mapTo: "reviewDate",
        },
        {
          name: "Certification Template",
          mapTo: "certificationTemplate",
        },
        {
          name: "Total Qualification Time",
          mapTo: "tqt",
        },
        {
          name: "Grading Criterion",
          mapTo: "gradingCriterion",
        },
        {
          name: "Grading Language",
          mapTo: "gradingLanguage",
        },
        {
          name: "Minimum Guided Learning Hours",
          mapTo: "minimumHour",
        },
        {
          name: "Number of Resits",
          mapTo: "noOfResits",
        },
        {
          name: "Delivery Mode",
          mapTo: "deliveryMode",
        },
      ],
    };
  },
  methods: {
    getUnits: async function () {
      const response = await fetch(`${process.env.VUE_APP_ROOT_API}/units`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      });

      const data = await response.json();
      this.units = data.units;
    },

    getUnitCodeById: function (id) {
      const units = this.units.filter((unit) => {
        return unit._id == id;
      });

      return units.length > 0 ? units[0].code : null;
    },

    getCertificationTemplates: async function () {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/templates?type=certification`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        }
      );

      const data = await response.json();
      this.certificationTemplates = data.templates;
    },

    getTemplateNameById: function (id) {
      const templates = this.certificationTemplates.filter((template) => {
        return template._id == id;
      });

      return templates.length > 0 ? templates[0].name : null;
    },

    getQualification: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.writeToTable(data.qualification);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    writeToTable: function (item) {
      this.mapper.map((key) => {
        Object.keys(item).map((i) => {
          if (key.mapTo == i) {
            let value;
            if (key.mapTo == "certificationTemplate") {
              value = this.getTemplateNameById(item[i]);
            } else if (
              key.mapTo == "mandatoryUnits" ||
              key.mapTo == "optionalUnits"
            ) {
              const units = [];
              item[i].map((unit) => {
                if (this.item) {
                  units.push(unit);
                } else {
                  units.push(this.getUnitCodeById(unit));
                }
              });

              value = units.join(", ");
            } else {
              value = item[i];
            }
            this.details.push({ name: key.name, value });
          }
        });
      });
    },
  },
};
</script>

<style scoped>
</style>